import { Component, EventEmitter, Input, OnInit, Optional, Output, SimpleChanges } from '@angular/core';
import { AuthService, EnvironmentConfig, GeneralService, IUser, Listing, ListingService } from '@clooper/core';
import lozad from 'lozad'
import { ToastrService } from 'ngx-toastr';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ActivatedRoute, Router } from '@angular/router';
import { faMapMarkerAlt } from '@fortawesome/pro-light-svg-icons/faMapMarkerAlt';
import { faBed } from '@fortawesome/pro-light-svg-icons/faBed';
import { faBath } from '@fortawesome/pro-light-svg-icons/faBath';
import { faBadgeCheck } from '@fortawesome/pro-light-svg-icons/faBadgeCheck';
import { faArrowRight } from '@fortawesome/pro-light-svg-icons/faArrowRight';
import { faArrowLeft } from '@fortawesome/pro-light-svg-icons/faArrowLeft';
import { faHeart } from '@fortawesome/pro-light-svg-icons/faHeart';


@Component({
  selector: 'app-property-search-listing',
  templateUrl: './property-search-listing.component.html',
  styleUrls: ['./property-search-listing.component.scss']
})
export class PropertySearchListingComponent implements OnInit {

  trustedString: string = 'This supplier is a member of a trade association or has been awarded ISO standards and is committed to providing high quality properties'

  icons = {
    map: faMapMarkerAlt,
    bed: faBed,
    bath: faBath,
    trusted: faBadgeCheck,
    arrowRight: faArrowRight,
    arrowLeft: faArrowLeft,
    heart: faHeart

  }

  favourite = false;
  user: IUser
  bsModalRef?: BsModalRef;

  @Input() listing: Listing
  @Input() selectedListing: boolean
  @Input() isMobile: boolean
  @Input() isModalCanceled: any
  queryParams: any = { checkIn: 0, checkOut: 0, adults: 0, pets: 0, children: 0, infants: 0 }



  @Output() onlistinghovered: EventEmitter<any> = new EventEmitter();
  @Output() isFavourite: EventEmitter<any> = new EventEmitter()
  max = 1;

  rate = 0;
  isReadonly = true;
  starRating: any;
  showBenchMark: boolean = false;


  constructor(
    @Optional() private authService: AuthService,
    private config: EnvironmentConfig,
    private service: ListingService,
    private toastr: ToastrService,
    private gs: GeneralService,
    private modalService: BsModalService,
    private route: ActivatedRoute,
    private router: Router


  ) {
    this.route.queryParams.subscribe((params: any) => {
      if (Object.keys(params).length !== 0) {
        this.queryParams = {
          checkIn: params.checkIn || 0,
          checkOut: params.checkOut || 0,
          adults: params.adults || 0,
          children: params.children || 0,
          pets: params.pets || 0,
          infants: params.infants || 0
        }

      }
    });
  }

  ngOnInit(): void {

    this.rate = this.listing?.review_rating;
    this.starRating = this.listing?.star_rating;

    if (location.origin === this.config.webappUrl) {
      this.user = this.authService.getAuthorizedUser()

      if (this.listing !== null && this.listing?.liked === true) {
        this.favourite = true;
      } else if (this.listing !== null && this.listing?.likes) {
        this.getPropertyLikeForAUser(this.listing?.likes)
      }
    }


    setTimeout(() => {
      const observer = lozad();
      observer.observe();
    }, 100);


  }

  addToFavourite(id: string, favourite: boolean) {
    if (location.origin === this.config.webappUrl) {
      if (this.favourite === false) {
        const payload = {
          toggle: true
        }
        this.service.toggleFavoriteProperty(payload, id).subscribe((res: Listing) => {
          this.favourite = true;
          const newData: Listing = this.listing;
          newData.likes = res.likes
          this.ngOnInit()

        }, err => {
          this.toastr.error(this.gs.getErrMsg(err))
        })

      } else {
        const payload = {
        }
        this.service.toggleFavoriteProperty(payload, id).subscribe((res: any) => {
          this.favourite = false;
          // const newData: Listing = this.listing;
          const newData: Listing = this.listing;
          newData.likes = res.likes

          this.ngOnInit()


        }, err => {
          this.toastr.error(this.gs.getErrMsg(err))
        })

      }
    } else {
      this.isFavourite.emit({ isFavorite: !favourite, id });

    }


  }

  viewProperty(id: string) {
    window.open(`/listings/${id}`, '_blank');


  }
  openRoomModal(id: any, platform: string) {
    sessionStorage.setItem('li_id', id)
    sessionStorage.setItem('li_pa', location.pathname)
    if (platform === 'clp-pl') { 
      if (this.router.url.includes('/bookings/create-booking')) {

        this.service.getPricelinePropertyCOntract({ id }).subscribe((res: any) => {
          const roomId = res.data.rooms[0].rate_data[0].ppn_bundle
          const { checkIn, checkOut, rooms, adults, children, pets, infants } = this.queryParams
          window.open(`/bookings/create-booking/listings/hotel-apartment/${roomId}?checkIn=${checkIn}&checkOut=${checkOut}&rooms=${rooms}&adults=${adults}&children=${children}&pets=${pets}&infants=${infants}`, '_blank');
        })
      } else {
      this.service.getPricelinePropertyCOntract({ id }).subscribe((res: any) => {
        const roomId = res.data.rooms[0].rate_data[0].ppn_bundle
        const { checkIn, checkOut, rooms, adults, children, pets, infants } = this.queryParams
        window.open(`/listings/hotel-apartment/${roomId}?checkIn=${checkIn}&checkOut=${checkOut}&rooms=${rooms}&adults=${adults}&children=${children}&pets=${pets}&infants=${infants}`, '_blank');
      })

    }
  } else {
    const { checkIn, checkOut, guests  } = this.queryParams
          const guestsQS = this.buildGuestsQueryString(guests);

    if (this.router.url.includes('/bookings/create-booking')) {
      window.open(`/bookings/create-booking/listings/hotel-apartments/${id}?checkIn=${checkIn}&checkOut=${checkOut}${guestsQS ? `&${guestsQS}` : ""}&tx=${'rk'}`, '_blank'); // tx is the tracking parameter for ratehawk
    } else {  
      window.open(`/listings/hotel-apartments/${id}?checkIn=${checkIn}&checkOut=${checkOut}${guestsQS ? `&${guestsQS}` : ""}&tx=${'rk'}`, '_blank'); // tx is the tracking parameter for ratehawk

    }
  }
}

  getPropertyLikeForAUser(id: string[]) {
    id.forEach(element => {
      if (element === this.user?.id) {
        this.favourite = true;
      }
    });


  }


    buildGuestsQueryString(guests: any): string {
    const rooms = guests ?? guests ?? [];
    const parts: string[] = [];
  
    rooms.forEach((room: any, i: number) => {
      parts.push(`guests[${i}][adults]=${Number(room.adults ?? 0)}`);
  
      const children = Array.isArray(room.children) ? room.children : [];
      parts.push(`guests[${i}][children]=[${children.map(Number).join(",")}]`);
    });
  
    return parts.join("&");
  }



}
